import { BrowserRouter, Routes, Route } from "react-router-dom";

// pages
import Login from "page/Login";
import ForgotPassword from "page/ForgotPassword";
import Layout from "../components/Layout";
import User from "../page/User";
import { AuthProvider } from "../context/AuthContext";
import PrivateRoute from "../components/PrivateRoute";
import MensagemEmail from "page/MensagemEmail";
import Lens from "page/Lens";
import Stock from "page/Stock";

export default function AppRoutes() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/recuperarsenha" element={<ForgotPassword />} />
                    <Route path="/mensagem-sucesso" element={<MensagemEmail />} />

                    <Route
                        element={
                            <PrivateRoute>
                                <Layout />
                            </PrivateRoute>
                        }>
                        <Route path="/usuario" element={<User />} />
                        <Route path="/lente" element={<Lens />} />
                        <Route path="/estoque" element={<Stock />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
